import { testings_api_testing_get_url } from 'mk/urls/functions';
import {
    testingDetailFetchApi,
    TestingDetailFetchNormalizedResponse,
    TestingDetailFetchTriggerAction,
    TESTING_DETAIL_FETCH_TRIGGER,
} from 'mk2/apps/testings/containers/TestingDetail/TestingDetail.actions';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('bo/TestingDetail.sagas');

interface ApiFetchResponse {
    body: {
        entities: TestingDetailFetchNormalizedResponse['entities'];
        result: TestingDetailFetchNormalizedResponse['result'];
    };
}

function* fetch({ testingHashtag, xhr }: TestingDetailFetchTriggerAction & XHRAction) {
    yield put(testingDetailFetchApi.request(testingHashtag));

    try {
        const response: ApiFetchResponse = yield call(
            () => xhr.get(testings_api_testing_get_url(testingHashtag)),
        );

        yield put(testingDetailFetchApi.success(testingHashtag, {
            entities: response.body.entities,
            result: response.body.result,
        }));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(testingDetailFetchApi.failure(testingHashtag, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(TESTING_DETAIL_FETCH_TRIGGER, fetch),
    ]);
}
